import {ItemType_Tb1688 } from "@/utils/constant/item";
import tb1688Handler from '@/views/order_before/components/orders_row/row_item_right_buttons_td/components/option_goods_btns/components/search_goods_by_img_modal/search_img_platfrom_handlers/tb1688/handler'
import { COU_Tb1688SearchImgFilterKey } from '@/utils/co_util'
var tb1688ItemInfo= { items: [],info:ItemType_Tb1688,loading:false,handler:tb1688Handler,filter:localStorage.getItem(COU_Tb1688SearchImgFilterKey())||''  }

const allItemInfos = [
  tb1688ItemInfo,

]

var itenInfoMap = []
allItemInfos.map(info=>{
  itenInfoMap[info.info.type] = info
})

const state = () => ({
  tb1688ItemInfo,
  searchImgUrl:"",
})

const getters = {
  searchImgUrl: (state) => state.searchImgUrl,
  itemInfos: (state) => {
    var itemInfos = [
      state.tb1688ItemInfo,
    ]
    return itemInfos
  }
}

function getItemInfoByType(state,type){
  var info = null
  switch(type){
    case ItemType_Tb1688.type:
    info = state.tb1688ItemInfo;break;
  }

  return info
}


const mutations = {
  setSearchLoadding(state, {type,loading}) {
    var itemInfo = getItemInfoByType(state,type)
    itemInfo.loading = loading
  },
  setSearchImgUrl(state, searchImgUrl) {
    if(!searchImgUrl)return
    if(searchImgUrl.includes("-item.ecombdimg.com")) searchImgUrl = searchImgUrl.replace(/p\d+-item.ecombdimg.com/,"p6-item.ecombdimg.com")
    state.searchImgUrl = searchImgUrl
  },
  setItems(state, {items,type}) {
    var itemInfo = getItemInfoByType(state,type)
    itemInfo.items = items
  },
}

const actions = {
  StartSearchImg({commit,state},{type,dyItemOrderInfo}){
    if(!state.searchImgUrl)return
    commit("setSearchLoadding",{type,loading:true})
    var info = itenInfoMap[type]
    var data = {imgUrl:state.searchImgUrl}
    if(info.filter) data.filter = info.filter
    info.handler.StartSearchImg(data,dyItemOrderInfo).then(items=>{
      commit("setItems",{items,type})
      commit("setSearchLoadding",{type,loading:false})
    })
  },
}


export default { state, getters, mutations, actions, allItemInfos}